module.exports = __webpack_public_path__ + "static/media/goingdown02.f287c07a.svg";